import algoliasearch from "algoliasearch/lite";

const searchClient = algoliasearch(process.env.ALGOLIA_APP_ID as string, process.env.ALGOLIA_API_KEY as string);

export default searchClient;
